import { type Auth0Client, createAuth0Client } from '@auth0/auth0-spa-js';

import { AUTH0_CLIENT_ID, AUTH0_DOMAIN } from './env';

let auth0Client: Auth0Client | null = null;

export const getAuthClient = async () => {
  if (!auth0Client) {
    auth0Client = await createAuth0Client({
      domain: AUTH0_DOMAIN,
      clientId: AUTH0_CLIENT_ID,
      cacheLocation: 'localstorage',
      authorizationParams: {
        redirect_uri: window.location.origin,
      },
    });
  }

  return auth0Client;
};

export const resetAuthClient = () => {
  auth0Client = null;
};

export const getToken = async (): Promise<string | undefined> => {
  const client = await getAuthClient();
  if (await client.isAuthenticated()) {
    return await client.getTokenSilently();
  } else {
    console.info('User is not authenticated, redirecting to login');
    client.loginWithRedirect();
  }
};
